module.exports = __webpack_public_path__ + "img/question-2.616203c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svetlana/question-2.png
// module id = NzEX
// module chunks = 1